import { useOrgTab } from '../../api/orgs';
import type { OrgHolds } from '../../api/types';
import { DataTable, type DataColumn } from '../../components/DataTable';
import { QueryView } from '../../components/QueryView';
import { Section } from '../../components/Section';
import { Timestamp } from '../../components/Timestamp';

type Exception = OrgHolds['order_exceptions'][number];
type Plan = OrgHolds['plans_on_hold'][number];

const EXCEPTION_COLUMNS: DataColumn<Exception>[] = [
  { id: 'order', header: 'Order', cell: item => item.order_id },
  { id: 'kind', header: 'Kind', cell: item => item.kind },
  { id: 'reason', header: 'Reason', cell: item => item.reason ?? '—' },
  {
    id: 'opened',
    header: 'Opened',
    cell: item => <Timestamp value={item.opened_at} />,
  },
];

const PLAN_COLUMNS: DataColumn<Plan>[] = [
  { id: 'plan', header: 'Plan', cell: item => item.plan_id },
  { id: 'order', header: 'Order', cell: item => item.order_id },
  {
    id: 'reason',
    header: 'Hold reason',
    cell: item => item.hold_reason ?? '—',
  },
  {
    id: 'held',
    header: 'On hold since',
    cell: item => <Timestamp value={item.held_since} />,
  },
];

export function HoldsTab({ orgId }: { orgId: string }) {
  return (
    <QueryView query={useOrgTab(orgId, 'holds')}>
      {({ order_exceptions, plans_on_hold }) => (
        <>
          <Section title="Open order exceptions">
            <DataTable
              label="Open order exceptions"
              columns={EXCEPTION_COLUMNS}
              rows={order_exceptions}
              getKey={item => item.id}
              empty="No open order exceptions"
            />
          </Section>
          <Section title="Plans on hold">
            <DataTable
              label="Plans on hold"
              columns={PLAN_COLUMNS}
              rows={plans_on_hold}
              getKey={item => item.plan_id}
              empty="No plans on hold"
            />
          </Section>
        </>
      )}
    </QueryView>
  );
}
